import React, { useEffect } from "react";
import "./quote.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { AOS } from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import header from "../../assets/header-img.svg";

const textVariant = {
  initial: {
    x: -500,
    opacity: 0,
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 1,
      staggerChildren: 0.1,
    },
  },
  scrollButton: {
    opacity: 1,
    scale: [1, 1.1, 1],
    transition: {
      yoyo: Infinity,
      ease: "easeInOut",
      duration: 2,
      stiffness: 10,
      repeat: Infinity,
    },
  },
};

function Quote() {
  return (
    <div className="message">
      <motion.div
        variants={textVariant}
        animate="animate"
        initial="initial"
        className="header-image"
      >
        <motion.img
          src={header}
          alt=""
          variants={textVariant}
          animate="scrollButton"
        />
      </motion.div>

      <div className="quote__container">
        <div className="quote">
          <motion.p initial={{ opacity: 1 }} whileHover={{ scale: 1 }}>
            The best thing about a boolean is even if you are wrong, you are
            only off by a bit <br />
            <span className="Dr">Dev mike</span>
          </motion.p>
        </div>

        {/* <div className="quote__icon__right">
          <FontAwesomeIcon icon={faQuoteRight} color="#9ab5e7" size="2xl" />
        </div> */}
      </div>
      <div className="box">
        <div className="box2"></div>
      </div>
    </div>
  );
}

export default Quote;
